<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">KPIs/PSIs Overview</h1>
      <p>
        Inside the <b>Project Details page</b>, there is <b>green button</b> that reads <b>"KPIs Overview"</b> in the KPIs tab,
        and a similar <b>"PSIs Overview"</b> in the PSIs tab. Each button, when clicked, redirects the user to a new page
        that presents a collective view of all the KPIs/PSIs of the project.
      </p>

      <div class="image-container">
        <img src="@/images/manual/projects-page-kpi-psi-overview.png" alt="kpis/psis overview button location" />
        <div class="img-caption">
          Figure 1. The "KPIs/PSIs Overview" button's location.
        </div>
      </div>

      <p>
        This minimalistic page, shows <b>10 items per page</b> by default and sorts the KPIs/PSIs by ID (with the ability
        to sort by any attribute, by pressing the corresponding column). For the KPIs, the <b>Name</b> and
        <b>Aggregation Level</b> values are displayed. KPIs using <b>Likert Scale</b> as a functional unit, will have a
        small indicative chip right next to their names.
      </p>

      <div class="image-container">
        <img src="@/images/manual/kpis-overview.png" alt="kpis overview page" />
        <div class="img-caption">
          Figure 2. The KPIs Overview Page.
        </div>
      </div>

      <p>
        As for the PSIs, thre presented attributes are: <b>the PSI's value</b>, <b>Target Value</b> and <b>Call Impact</b>.
        Also, PSIs using <b>Relative Margins</b> (just like the Likert Scale), will have a small indicative chip right
        next to their names. Both in the KPIs and the PSIs, the user can <b>edit</b> a KPI/PSI, by clicking the
        <i class="fas fa-pen" /> button.
      </p>

      <div class="image-container">
        <img src="@/images/manual/psis-overview.png" alt="psis overview page" />
        <div class="img-caption">
          Figure 3. The PSIs Overview Page.
        </div>
      </div>

      <p>
        In each of the overview pages (KPIs or PSIs) the user has the option to <b>bulk update</b> the values of the indicators.
        First, the user should <b>download the template file</b> by clicking the <b>"<i class="fas fa-download" /> Download template" button</b> at the bottom of the
        page. Then, after this file is filled with the required data, the user can upload the file and update the values
        of the indicators. To upload the file the user should click the <b>"Update values" button.</b> After the button is clicked,
        a modal will appear on the screen that will prompt the user to upload their file. Finally, the user should click
        the "Submit" button and if the a valid file was provided the table of the indicators will be updated, displaying
        the new values.
      </p>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
